import {configureStore} from '@reduxjs/toolkit'

const store = configureStore({
  reducer: {
    // You can add your reducers here
    // For example, a simple counter reducer:
    counter: (state = 0, action) => {
      switch (action.type) {
        case 'increment':
          return state + 1
        case 'decrement':
          return state - 1
        default:
          return state
      }
    },
  },
})

export default store
